import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, CreditCardIcon, ChevronDownIcon, StarIcon, AlertTriangleIcon, BookOpenIcon, UsersIcon, TrendingUpIcon, GlobeIcon, FileTextIcon, LockIcon, ZapIcon, BriefcaseIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { PricingGrid } from './PricingGrid';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/5SnJm2Hi7cUWHZvTryu786/conjunto_de_mockups_marketing.png'
};
const LINKS = {
  PACK_COMPLETO: 'https://checkout.kitonline.shop/cart/47799363797230:1',
  PACK_PREMIUM: 'https://checkout.kitonline.shop/cart/47799363928302:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(0);
  const packLinks = [LINKS.PACK_COMPLETO, LINKS.PACK_PREMIUM];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-300 bg-[#0a0e27] min-h-screen flex flex-col" data-id="element-36">
      <CountdownTimer data-id="element-37" />
      <SocialProofPopup data-id="element-38" />

      {/* HERO */}
      <section className="py-3 md:py-5 px-3 md:px-4 text-center" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0c1333 50%, #0f172a 100%)'
    }} data-id="element-39">
        <div className="max-w-3xl mx-auto" data-id="element-40">
          <p className="text-[#06b6d4] text-[10px] md:text-xs font-black uppercase tracking-widest mb-1 drop-shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-41">
            ⭐ EL RECURSO #1 PARA DOCENTES DE MARKETING Y EMPRENDIMIENTO ⭐
          </p>

          <h1 className="text-xl md:text-3xl lg:text-4xl font-black text-white mb-1 leading-tight uppercase drop-shadow-md" data-id="element-42">
            Dejá de perder horas preparando clases, proyectos y actividades
            desde cero
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity my-2 md:my-3" data-id="element-43">
            <img src={IMAGES.MAIN} alt="Kit Completo Marketing y Emprendimiento Mockup" className="w-full max-w-md mx-auto drop-shadow-[0_0_40px_rgba(6,182,212,0.3)]" data-id="element-44" />
          </div>

          <p className="text-sm md:text-lg text-[#22d3ee] font-black italic mb-1 uppercase drop-shadow-[0_0_8px_rgba(6,182,212,0.3)]" data-id="element-45">
            Todo listo para usar. Sin buscar más.
          </p>

          <p className="text-xs md:text-sm text-gray-300 mb-2 max-w-xl mx-auto font-medium" data-id="element-46">
            El sistema que usan los docentes para planificar TODO el año en una
            sola tarde
          </p>

          <div className="flex justify-center gap-1 md:gap-2 mb-2 flex-nowrap" data-id="element-47">
            <span className="flex items-center gap-0.5 border border-cyan-500/40 bg-[#0d1530]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-48">
              <FileTextIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#06b6d4]" data-id="element-49" />{' '}
              100% PDF
            </span>
            <span className="flex items-center gap-0.5 border border-cyan-500/40 bg-[#0d1530]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-50">
              <ZapIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#06b6d4]" data-id="element-51" />{' '}
              Acceso inmediato
            </span>
            <span className="flex items-center gap-0.5 border border-cyan-500/40 bg-[#0d1530]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-52">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <button onClick={scrollToPricing} className="cta-pulse inline-flex items-center justify-center bg-[#06b6d4] hover:bg-[#0891b2] text-black font-black text-xs md:text-base py-2 px-4 md:py-3 md:px-8 rounded-lg transition-all duration-200 mb-1.5 whitespace-nowrap uppercase" data-id="element-53">
            → QUIERO MI KIT COMPLETO AHORA
          </button>

          <div className="flex justify-center gap-1.5 md:gap-3 text-[9px] md:text-[10px] text-gray-300 font-bold flex-nowrap uppercase tracking-wider" data-id="element-54">
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-55">
              <ShieldCheckIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#06b6d4]" data-id="element-56" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-57">
              <LockIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#06b6d4]" data-id="element-58" />{' '}
              Pago seguro
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-59">
              <ZapIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#06b6d4]" data-id="element-60" />{' '}
              Acceso inmediato
            </span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0f172a 0%, #111827 100%)'
    }} data-id="element-61">
        <div className="max-w-2xl mx-auto" data-id="element-62">
          <h2 className="text-xl md:text-2xl font-black text-center text-red-500 mb-2 uppercase drop-shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-63">
            <span className="underline decoration-red-500/50 decoration-4 underline-offset-2" data-id="element-64">
              ❌ ¿Te pasa esto?
            </span>
          </h2>

          <div className="space-y-1 md:space-y-1.5 text-sm md:text-base text-gray-200 font-medium leading-snug bg-[#0d1530]/80 backdrop-blur-sm p-3 md:p-5 rounded-xl border-2 border-cyan-500/40 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-65">
            <p className="flex items-start gap-1.5" data-id="element-66">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-67">
                ❌
              </span>
              Buscás material de marketing o emprendimiento… y encontrás
              contenido genérico que no sirve para secundaria
            </p>
            <p className="flex items-start gap-1.5" data-id="element-68">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-69">
                ❌
              </span>
              Tenés que armar actividades desde cero porque no existe material
              completo y organizado
            </p>
            <p className="flex items-start gap-1.5" data-id="element-70">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-71">
                ❌
              </span>
              Tus alumnos viven en redes… pero no sabés cómo llevar eso al aula
            </p>
            <p className="flex items-start gap-1.5" data-id="element-72">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-73">
                ❌
              </span>
              Las planificaciones y evaluaciones te consumen horas que no tenés
            </p>
            <p className="flex items-start gap-1.5" data-id="element-74">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-75">
                ❌
              </span>
              Querés dar clases más dinámicas y reales… pero no tenés el
              material estructurado
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA PERSUASIVE CTA */}
      <section className="py-2 md:py-4 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #111827 0%, #0d1224 100%)'
    }} data-id="element-76">
        <div className="flex flex-col items-center gap-2" data-id="element-77">
          <button onClick={scrollToPricing} className="cta-pulse bg-[#06b6d4] hover:bg-[#0891b2] text-black font-black text-sm md:text-lg py-2.5 px-4 md:py-3 md:px-6 rounded-lg transition-all duration-200 w-full md:w-auto max-w-xl uppercase" data-id="element-78">
            🔥 ¡QUIERO DEJAR DE IMPROVISAR Y TENER TODO RESUELTO!
          </button>

          <button onClick={scrollToPricing} className="cta-pulse-red border-2 border-red-500 bg-red-500/10 hover:bg-red-500/20 text-red-400 font-black text-xs md:text-sm py-2 px-4 md:py-2.5 md:px-6 rounded-lg transition-all duration-200 w-full md:w-auto max-w-xl uppercase backdrop-blur-sm" data-id="element-79">
            🚀 ¡ACCEDÉ AL KIT AHORA CON 50% OFF!
          </button>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-3 md:py-5 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #0d1224 0%, #0b1a3a 100%)'
    }} data-id="element-80">
        <div className="max-w-3xl mx-auto" data-id="element-81">
          <span className="inline-block bg-[#06b6d4] text-black text-[10px] font-black px-2 py-0.5 rounded-full mb-1 uppercase tracking-widest shadow-[0_0_10px_rgba(6,182,212,0.4)]" data-id="element-82">
            La Solución
          </span>
          <h2 className="text-xl md:text-3xl font-black text-white mb-2 uppercase drop-shadow-md" data-id="element-83">
            CON ESTE KIT{' '}
            <span className="text-white underline decoration-[#06b6d4] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(6,182,212,0.3)]" data-id="element-84">
              VAS A PODER:
            </span>
          </h2>

          <div className="flex flex-col items-center gap-1 md:gap-1.5 text-sm md:text-base font-bold text-white text-left max-w-xl mx-auto bg-[#0d1530]/80 backdrop-blur-sm p-3 md:p-5 rounded-xl border-2 border-cyan-500/40 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-85">
            <span className="flex items-start gap-2 w-full" data-id="element-86">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-87">
                ✅
              </span>
              Dar clases de marketing y emprendimiento con contenido ACTUAL,
              claro y listo para usar
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-88">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-89">
                ✅
              </span>
              Tener actividades, proyectos y evaluaciones sin preparar nada
              adicional
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-90">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-91">
                ✅
              </span>
              Conectar con tus alumnos usando redes sociales, marcas y casos
              reales
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-92">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-93">
                ✅
              </span>
              Organizar TODO tu año sin improvisar
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-94">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-95">
                ✅
              </span>
              Ahorrar horas de trabajo todas las semanas
            </span>
          </div>
        </div>
      </section>

      {/* CONTENTS ACCORDION */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0b1a3a 0%, #101530 100%)'
    }} data-id="element-96">
        <div className="max-w-3xl mx-auto" data-id="element-97">
          <div className="text-center mb-3 md:mb-4" data-id="element-98">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1 uppercase drop-shadow-md" data-id="element-99">
              📦 ¿QUÉ INCLUYE EL{' '}
              <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-2 drop-shadow-[0_0_10px_rgba(6,182,212,0.3)]" data-id="element-100">
                KIT?
              </span>
            </h2>
            <p className="text-sm md:text-base text-[#22d3ee] font-black mb-1 uppercase drop-shadow-[0_0_5px_rgba(6,182,212,0.2)]" data-id="element-101">
              📚 +400 páginas · 6 tomos · Listo para usar todo el año
            </p>
          </div>

          <div className="space-y-1 md:space-y-1.5" data-id="element-102">
            {/* Tomo 1 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-103">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 0 ? null : 0)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-104">
                <BookOpenIcon className="w-5 h-5 md:w-6 md:h-6 text-blue-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(96,165,250,0.5)]" data-id="element-105" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-106">
                  TOMO 1 — Fundamentos del Marketing y el Consumidor
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 0 ? 'rotate-180' : ''}`} data-id="element-107" />
              </button>
              <AnimatePresence data-id="element-108">
                {openCuadernillo === 0 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-109">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-110">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-111">
                        Qué es el marketing hoy. Necesidades, deseos y
                        decisiones de compra. Tipos de consumidores.
                        Comportamiento del consumidor. Incluye: actividades
                        prácticas, análisis de marcas reales, debates guiados,
                        casos actuales.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 2 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-112">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 1 ? null : 1)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-113">
                <TrendingUpIcon className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-114" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-115">
                  TOMO 2 — Investigación de Mercado y Cliente Ideal
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 1 ? 'rotate-180' : ''}`} data-id="element-116" />
              </button>
              <AnimatePresence data-id="element-117">
                {openCuadernillo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-118">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-119">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-120">
                        Segmentación de mercado. Cliente ideal. Encuestas y
                        análisis. Validación de ideas. Incluye: creación de
                        encuestas, análisis de datos, trabajos prácticos,
                        investigación aplicada.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 3 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-121">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 2 ? null : 2)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-122">
                <UsersIcon className="w-5 h-5 md:w-6 md:h-6 text-amber-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(251,191,36,0.5)]" data-id="element-123" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-124">
                  TOMO 3 — Producto, Marca y Propuesta de Valor
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 2 ? 'rotate-180' : ''}`} data-id="element-125" />
              </button>
              <AnimatePresence data-id="element-126">
                {openCuadernillo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-127">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-128">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-129">
                        Creación de productos. Branding (nombre, identidad,
                        logo). Diferenciación. Propuesta de valor. Incluye:
                        creación de marcas desde cero, actividades creativas,
                        trabajos grupales, ejercicios aplicados.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 4 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-130">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 3 ? null : 3)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-131">
                <GlobeIcon className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(248,113,113,0.5)]" data-id="element-132" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-133">
                  TOMO 4 — Marketing Digital y Redes Sociales
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 3 ? 'rotate-180' : ''}`} data-id="element-134" />
              </button>
              <AnimatePresence data-id="element-135">
                {openCuadernillo === 3 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-136">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-137">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-138">
                        Redes sociales en marketing. Contenido digital.
                        Algoritmos y viralización. Estrategias básicas. Incluye:
                        análisis de Instagram y TikTok, creación de contenido,
                        actividades prácticas, campañas simuladas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 5 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-139">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 4 ? null : 4)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-140">
                <BriefcaseIcon className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(250,204,21,0.5)]" data-id="element-141" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-142">
                  TOMO 5 — Ventas y Estrategias Comerciales
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 4 ? 'rotate-180' : ''}`} data-id="element-143" />
              </button>
              <AnimatePresence data-id="element-144">
                {openCuadernillo === 4 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-145">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-146">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-147">
                        Técnicas de venta. Comunicación con clientes.
                        Estrategias comerciales. Objeciones. Incluye:
                        simulaciones de venta, role play en clase, actividades
                        aplicadas, ejercicios prácticos.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 6 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 overflow-hidden transition-all hover:border-cyan-400/70 shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-148">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 5 ? null : 5)} className="w-full flex items-center gap-2 p-2.5 md:p-3 text-left cursor-pointer" data-id="element-149">
                <FileTextIcon className="w-5 h-5 md:w-6 md:h-6 text-purple-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(192,132,252,0.5)]" data-id="element-150" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-151">
                  TOMO 6 — Proyecto Integrador de Emprendimiento
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#06b6d4] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 5 ? 'rotate-180' : ''}`} data-id="element-152" />
              </button>
              <AnimatePresence data-id="element-153">
                {openCuadernillo === 5 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a0e27]/50" data-id="element-154">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3 border-t border-cyan-500/20 pt-2.5 md:pt-3" data-id="element-155">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-156">
                        Creación de negocio completo. Modelo de negocio. Costos
                        y precios. Presentación final. Incluye: guía paso a
                        paso, proyectos reales, rúbricas completas, evaluación
                        final.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #101530 0%, #0c1333 100%)'
    }} data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <div className="text-center mb-3" data-id="element-159">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1 uppercase leading-tight drop-shadow-md" data-id="element-160">
              <span className="text-[#06b6d4] drop-shadow-[0_0_10px_rgba(6,182,212,0.4)]" data-id="element-161">
                🎁 BONUS EXCLUSIVOS
              </span>{' '}
              INCLUIDOS
            </h2>

            <div className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-[10px] md:text-xs px-3 md:px-5 py-1 md:py-1.5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.6)] border border-red-400 mb-2 uppercase tracking-widest" data-id="element-162">
              <span className="text-sm md:text-base" data-id="element-163">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-3" data-id="element-164">
            {/* Bonus 1 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-165">
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(220,38,38,0.5)]" data-id="element-166">
                BONUS 1
              </span>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-167">
                📋 Planificación Anual Completa
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-168">
                Organización de todo el año. Secuencia de contenidos. Objetivos
                claros. Plan listo para aplicar.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-cyan-500/30" data-id="element-169">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-170">
                  Valor $8.500
                </span>
                <span className="bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-171">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-172">
              <span className="inline-block bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-173">
                BONUS 2
              </span>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-174">
                📚 100 Actividades de Marketing y Emprendimiento
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-175">
                Actividades con redes sociales. Creación de marcas. Dinámicas
                grupales. Casos reales.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-cyan-500/30" data-id="element-176">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-177">
                  Valor $8.500
                </span>
                <span className="bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-178">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-179">
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(220,38,38,0.5)]" data-id="element-180">
                BONUS 3
              </span>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-181">
                📊 Sistema PRO de Evaluación
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-182">
                Evaluaciones listas. Rúbricas profesionales. Evaluación por
                unidad. Instrumentos completos.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-cyan-500/30" data-id="element-183">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-184">
                  Valor $8.000
                </span>
                <span className="bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-185">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 4 */}
            <div className="bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(6,182,212,0.2)]" data-id="element-186">
              <span className="inline-block bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-187">
                BONUS 4
              </span>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-188">
                🚀 10 Proyectos Listos para el Aula
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-189">
                Proyectos completos paso a paso. Emprendimientos reales.
                Aplicación directa en clase. Evaluación incluida.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-cyan-500/30" data-id="element-190">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-191">
                  Valor $9.000
                </span>
                <span className="bg-[#06b6d4] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(6,182,212,0.5)]" data-id="element-192">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="max-w-xs mx-auto bg-[#0d1530]/90 backdrop-blur-sm border-2 border-cyan-500/50 rounded-xl p-3 text-center shadow-[0_0_20px_rgba(6,182,212,0.15)]" data-id="element-193">
            <p className="text-gray-300 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-194">
              Valor total de los 4 bonus:
            </p>
            <p className="text-white text-lg md:text-xl font-black line-through decoration-red-500 decoration-4 mb-1 drop-shadow-sm" data-id="element-195">
              $34.000
            </p>
            <p className="text-gray-300 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-196">
              Hoy te los llevás por:
            </p>
            <p className="text-[#06b6d4] text-3xl md:text-4xl font-black mb-1 drop-shadow-[0_0_10px_rgba(6,182,212,0.4)]" data-id="element-197">
              $0
            </p>
            <p className="text-[#06b6d4] font-black text-[9px] md:text-[10px] uppercase tracking-widest" data-id="element-198">
              ✨ Incluidos GRATIS con tu compra ✨
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0c1333 0%, #0a0e27 100%)'
    }} data-id="element-199">
        <div className="max-w-2xl mx-auto text-center" data-id="element-200">
          <h2 className="text-lg md:text-2xl font-black text-[#06b6d4] mb-2 uppercase tracking-wider drop-shadow-[0_0_8px_rgba(6,182,212,0.3)]" data-id="element-201">
            El precio de lanzamiento termina en
          </h2>

          <div className="flex items-center justify-center gap-1.5 md:gap-3 mb-2" data-id="element-202">
            <div className="flex flex-col items-center" data-id="element-203">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-204">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-205">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-206">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-207">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-208">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-209">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-210">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-211">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-212">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-213">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-214">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-215">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-216">
                Segundos
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1 mb-2" data-id="element-217">
            <span className="flex items-center gap-1 bg-[#0d1530]/80 backdrop-blur-sm border border-cyan-500/40 shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-218">
              🔥 Últimas unidades
            </span>
            <span className="flex items-center gap-1 bg-[#0d1530]/80 backdrop-blur-sm border border-cyan-500/40 shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-219">
              📢 Oferta Lanzamiento
            </span>
            <span className="flex items-center gap-1 bg-[#0d1530]/80 backdrop-blur-sm border border-cyan-500/40 shadow-[0_0_10px_rgba(6,182,212,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-220">
              📈 Precio sube al terminar
            </span>
          </div>

          <div className="max-w-sm mx-auto" data-id="element-221">
            <div className="relative w-full h-2.5 bg-[#0a0e27] rounded-full overflow-hidden border border-cyan-500/30 shadow-[inset_0_0_5px_rgba(0,0,0,0.5)]" data-id="element-222">
              <div className="h-full rounded-full shadow-[0_0_10px_rgba(239,68,68,0.8)]" style={{
              width: '72%',
              background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)'
            }} data-id="element-223" />
            </div>
            <p className="text-[#06b6d4] text-[9px] font-black mt-1 uppercase tracking-widest drop-shadow-sm" data-id="element-224">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0c1333 50%, #0a0e27 100%)'
    }} data-id="element-225">
        <div className="max-w-4xl mx-auto" data-id="element-226">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 uppercase drop-shadow-md" data-id="element-227">
            Elegí tu{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(6,182,212,0.3)]" data-id="element-228">
              Kit Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-229" />

          {/* Features Box */}
          <div className="max-w-xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm border-2 border-cyan-500/60 shadow-[0_0_20px_rgba(6,182,212,0.2)] rounded-xl p-3" data-id="element-230">
            <h3 className="text-white font-black text-xs md:text-sm mb-2 flex items-center gap-1.5 uppercase tracking-wider drop-shadow-sm" data-id="element-231">
              👑 KIT COMPLETO INCLUYE:
            </h3>
            <ul className="space-y-1" data-id="element-232">
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-233">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-234" />
                6 tomos de marketing y emprendimiento para todo el año
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-235">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-236" />
                BONUS: Planificación Anual Completa
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-237">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-238" />
                BONUS: 100 Actividades de Marketing y Emprendimiento
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-239">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-240" />
                BONUS: Sistema PRO de Evaluación
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-241">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-242" />
                BONUS: 10 Proyectos Listos para el Aula
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-243">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-244" />
                Entrega inmediata por Drive (PDF)
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-245">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-246" />
                Acceso de por vida — sin vencimiento
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-247">
                <CheckIcon className="w-3.5 h-3.5 text-[#06b6d4] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-248" />
                Garantía de satisfacción de 7 días
              </li>
            </ul>
          </div>

          <p className="text-center text-gray-400 text-[9px] md:text-[10px] mt-2 flex items-center justify-center gap-1 font-bold uppercase tracking-widest" data-id="element-249">
            <CreditCardIcon className="w-3 h-3 text-[#06b6d4]" data-id="element-250" />
            Transferencia · Mercado Pago · Tarjeta
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-3 md:py-4 px-4" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0d1530 100%)'
    }} data-id="element-251">
        <div className="max-w-2xl mx-auto text-center" data-id="element-252">
          <h2 className="text-base md:text-lg font-black text-white mb-2 uppercase drop-shadow-md" data-id="element-253">
            🔽 ¿Cómo recibís el{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(6,182,212,0.3)]" data-id="element-254">
              material
            </span>
            ?
          </h2>

          <div className="grid grid-cols-3 gap-1.5 md:gap-3" data-id="element-255">
            <div className="relative" data-id="element-256">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#06b6d4] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(6,182,212,0.4)] border border-cyan-200" data-id="element-257">
                1
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-258">
                Comprás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-259">
                Ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-260">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#06b6d4] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(6,182,212,0.4)] border border-cyan-200" data-id="element-261">
                2
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-262">
                Pagás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-263">
                Pago seguro.
              </p>
            </div>
            <div className="relative" data-id="element-264">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#06b6d4] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(6,182,212,0.4)] border border-cyan-200" data-id="element-265">
                3
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-266">
                Descargás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-267">
                Recibís el link.
              </p>
            </div>
          </div>

          <div className="mt-2 bg-[#0d1530]/80 backdrop-blur-sm border-2 border-cyan-500/40 shadow-[0_0_10px_rgba(6,182,212,0.15)] rounded-lg p-1.5 inline-block" data-id="element-268">
            <p className="text-gray-200 flex items-center justify-center gap-1 font-bold text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-269">
              <AlertTriangleIcon className="w-3 h-3 text-[#06b6d4] drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-270" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-3 md:py-4 px-4 border-t-2 border-cyan-500/20" style={{
      background: 'linear-gradient(180deg, #0d1530 0%, #0a0e27 100%)'
    }} data-id="element-271">
        <div className="max-w-2xl mx-auto text-center" data-id="element-272">
          <ShieldCheckIcon className="w-10 h-10 md:w-12 md:h-12 text-[#06b6d4] mx-auto mb-1.5 drop-shadow-[0_0_15px_rgba(6,182,212,0.6)]" data-id="element-273" />
          <h2 className="text-lg md:text-xl font-black text-white mb-1 uppercase drop-shadow-md" data-id="element-274">
            Garantía de{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(6,182,212,0.3)]" data-id="element-275">
              Satisfacción Total
            </span>
          </h2>
          <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-276">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-3 md:py-5 px-4 border-t-2 border-cyan-500/20" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0c1333 100%)'
    }} data-id="element-277">
        <div className="max-w-4xl mx-auto" data-id="element-278">
          <h2 className="text-xl md:text-3xl font-black text-center text-white mb-3 uppercase drop-shadow-md" data-id="element-279">
            <span className="text-[#06b6d4] drop-shadow-[0_0_10px_rgba(6,182,212,0.4)]" data-id="element-280">
              Testimonios
            </span>{' '}
            de Docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" data-id="element-281">
            <div className="bg-[#0d1530]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-cyan-500/30 shadow-[0_0_10px_rgba(6,182,212,0.1)] hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-282">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-283">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-284" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-285" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-286" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-287" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-288" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-289">
                "Doy Marketing en una técnica y siempre me costaba encontrar
                material actualizado. Este kit tiene todo: desde fundamentos
                hasta proyectos de emprendimiento reales. Los chicos armaron sus
                propias marcas y fue increíble. Me ahorró meses de trabajo."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-290">
                Laura M., 32 años –{' '}
                <span className="text-[#06b6d4] font-bold" data-id="element-291">
                  Córdoba Capital
                </span>
              </div>
            </div>

            <div className="bg-[#0d1530]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-cyan-500/30 shadow-[0_0_10px_rgba(6,182,212,0.1)] hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-292">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-293">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-294" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-295" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-296" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-297" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-298" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-299">
                "Tengo Marketing y Emprendimiento en dos escuelas y antes perdía
                fines de semana armando clases. Con este kit abro el PDF y ya
                tengo todo listo. Las actividades con redes sociales y marcas
                reales enganchan a los alumnos al toque."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-300">
                Martín R., 38 años –{' '}
                <span className="text-[#06b6d4] font-bold" data-id="element-301">
                  Rosario, Santa Fe
                </span>
              </div>
            </div>

            <div className="bg-[#0d1530]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-cyan-500/30 shadow-[0_0_10px_rgba(6,182,212,0.1)] hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-302">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-303">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-304" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-305" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-306" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-307" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-308" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-309">
                "Lo mejor son los proyectos integradores. Mis alumnos crearon
                emprendimientos completos con modelo de negocio, marca y
                estrategia de ventas. Los directivos quedaron impresionados. El
                material es de otro nivel."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-310">
                Valeria S., 29 años –{' '}
                <span className="text-[#06b6d4] font-bold" data-id="element-311">
                  La Plata, Buenos Aires
                </span>
              </div>
            </div>

            <div className="bg-[#0d1530]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-cyan-500/30 shadow-[0_0_10px_rgba(6,182,212,0.1)] hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-312">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-313">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-314" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-315" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-316" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-317" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-318" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-319">
                "Soy docente hace 20 años y nunca encontré algo tan completo
                para marketing. Las rúbricas y evaluaciones me facilitan todo.
                La planificación anual que viene de bonus es un golazo, la
                presenté tal cual."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-320">
                Diego F., 45 años –{' '}
                <span className="text-[#06b6d4] font-bold" data-id="element-321">
                  San Miguel de Tucumán
                </span>
              </div>
            </div>

            <div className="bg-[#0d1530]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-cyan-500/30 shadow-[0_0_10px_rgba(6,182,212,0.1)] hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-322">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-323">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-324" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-325" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-326" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-327" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-328" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-329">
                "Mis alumnos se aburrían con la teoría de siempre. Con las
                actividades de Instagram, TikTok y creación de marcas ahora
                participan solos. El kit conecta el marketing con su vida real y
                eso hace toda la diferencia."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-330">
                Carolina P., 35 años –{' '}
                <span className="text-[#06b6d4] font-bold" data-id="element-331">Mendoza</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0c1333 0%, #0a0e27 100%)'
    }} data-id="element-332">
        <div className="max-w-2xl mx-auto" data-id="element-333">
          <h2 className="text-xl md:text-2xl font-black text-center text-white mb-3 uppercase drop-shadow-md" data-id="element-334">
            Preguntas{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(6,182,212,0.3)]" data-id="element-335">
              Frecuentes
            </span>
          </h2>

          <div className="space-y-1 md:space-y-1.5" data-id="element-336">
            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-337">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-338">
                ¿En qué formato recibo el material?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-339" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-340">
                Todo el material viene en formato PDF, listo para descargar,
                imprimir o usar de forma digital.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-341">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-342">
                ¿Cuánto tarda en llegar después de pagar?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-343" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-344">
                El acceso es inmediato. Apenas completás el pago, recibís el
                link de descarga en tu correo.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-345">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-346">
                ¿Puedo imprimir el material y usarlo en varias divisiones?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-347" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-348">
                Sí, podés imprimirlo todas las veces que necesites. El acceso es
                de por vida.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-349">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-350">
                ¿Está alineado al currículo?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-351" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-352">
                Sí, está diseñado específicamente para materias de Marketing y
                Emprendimiento en secundaria argentina.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-353">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-354">
                ¿Qué pasa si no me sirve?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-355" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-356">
                Tenés 7 días de garantía total. Si no cumple tus expectativas,
                te devolvemos el 100% de tu dinero.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-357">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-358">
                ¿Para qué año de secundaria sirve?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-359" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-360">
                Sirve para todos los años donde se dicte Marketing,
                Emprendimiento o materias afines.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-361">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-362">
                No tengo tarjeta de crédito, ¿puedo pagar de otra forma?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-363" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-364">
                Sí, aceptamos múltiples medios de pago: transferencia, Mercado
                Pago, débito y crédito.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-365">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-366">
                ¿Incluye planificación anual?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-367" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-368">
                Sí, como bonus incluimos una Planificación Anual completa lista
                para presentar.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-369">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-370">
                ¿Sirve si ya empecé el año?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-371" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-372">
                ¡Sí! El material está organizado por tomos temáticos
                independientes. Podés empezar por el tema que necesites.
              </div>
            </details>

            <details className="group bg-[#0d1530]/80 backdrop-blur-sm rounded-lg border-2 border-cyan-700/30 open:border-cyan-500/60 open:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all duration-200" data-id="element-373">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-374">
                ¿Qué diferencia hay entre el kit de $19.990 y el de $27.990?
                <ChevronDownIcon className="w-4 h-4 text-[#06b6d4] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-375" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-cyan-500/20 pt-2.5" data-id="element-376">
                El de $27.990 incluye el Sistema Avanzado de Emprendimientos
                para trabajar creación de negocios reales y estrategias
                profundas.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* BOTTOM PRICING */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0c1333 50%, #0a0e27 100%)'
    }} data-id="element-377">
        <div className="max-w-4xl mx-auto" data-id="element-378">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 uppercase drop-shadow-md" data-id="element-379">
            Elegí tu{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(6,182,212,0.3)]" data-id="element-380">
              Kit Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-381" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-3 md:py-5 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #0a0e27 0%, #0f172a 100%)'
    }} data-id="element-382">
        <div className="max-w-3xl mx-auto" data-id="element-383">
          <h2 className="text-xl md:text-3xl font-black text-white mb-1 uppercase drop-shadow-md" data-id="element-384">
            ¿Listo/a para transformar tu año en{' '}
            <span className="underline decoration-[#06b6d4] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(6,182,212,0.3)]" data-id="element-385">
              Marketing y Emprendimiento
            </span>
            ?
          </h2>
          <p className="text-xs md:text-sm text-gray-300 mb-2 font-bold uppercase tracking-wider" data-id="element-386">
            Más de 3.000 docentes ya lo están usando.
          </p>

          <p className="text-[#06b6d4] font-black uppercase tracking-widest text-[9px] md:text-[10px] drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-387">
            📈 KIT COMPLETO MARKETING Y EMPRENDIMIENTO LISTO
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="bg-[#0a0e27] py-2 px-4 text-center border-t-2 border-cyan-500/20" data-id="element-388">
        <p className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-389">
          ¿Tenés dudas? Escribinos a{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-[#06b6d4] font-black hover:underline drop-shadow-[0_0_5px_rgba(6,182,212,0.5)]" data-id="element-390">
            kitonline27@gmail.com
          </a>
        </p>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0a0e27] text-gray-500 py-3 px-4 text-center text-[9px] md:text-[10px] border-t border-[#1e293b] font-bold uppercase tracking-widest" data-id="element-391">
        <p className="mb-1.5" data-id="element-392">
          © 2026 Kit Completo Marketing y Emprendimiento Listo™
        </p>
        <div className="flex justify-center gap-3 md:gap-4" data-id="element-393">
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-394">
            Términos
          </span>
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-395">
            Privacidad
          </span>
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-396">
            Soporte
          </span>
        </div>
      </footer>
    </div>;
}